import { api, API_BASE } from './api';
import { DirectDebit, DirectDebitStats, DirectDebitFilter, Company, DirectDebitTransaction, DirectDebitUser, DirectDebitAttachment } from '../types/direct-debit';

export const financeApi = {
    // Direct Debits
    listDirectDebits: (filters: DirectDebitFilter = {}) => {
        const params = new URLSearchParams();
        if (filters.status && filters.status !== 'all') params.append('status', filters.status);
        if (filters.frequency && filters.frequency !== 'all') params.append('frequency', filters.frequency);
        if (filters.approvalStatus && filters.approvalStatus !== 'all') params.append('approvalStatus', filters.approvalStatus);
        if (filters.companyId) params.append('companyId', filters.companyId);
        if (filters.q) params.append('q', filters.q);
        
        return api.get<{ data: DirectDebit[], total: number }>(`/api/finance/direct-debit?${params.toString()}`);
    },

    getDirectDebit: (id: string) => api.get<DirectDebit>(`/api/finance/direct-debit/${id}`),

    getActivityLogs: (id: string) => api.get<any[]>(`/api/finance/direct-debit/${id}/activity`),

    createDirectDebit: (data: any) => api.post<DirectDebit>('/api/finance/direct-debit', data),

    updateDirectDebit: (id: string, data: any) => api.put<DirectDebit>(`/api/finance/direct-debit/${id}`, data),

    deleteDirectDebit: (id: string) => api.delete(`/api/finance/direct-debit/${id}`),

    // Stats & Trends
    getDashboardStats: () => api.get<DirectDebitStats>('/api/finance/direct-debit/stats'),

    getYearlyTrends: (year: number) => api.get<{ month: string, amount: number }[]>(`/api/finance/direct-debit/trends?year=${year}`),

    // Users
    listUsers: () => api.get<DirectDebitUser[]>('/api/finance/users'),

    updateUserAccess: (id: string, data: { hasAccess: boolean, accessLevel: string }) => 
        api.patch<{ message: string, accessLevel?: string }>(`/api/finance/users/${id}/access`, data),

    // Companies
    listCompanies: () => api.get<Company[]>('/api/finance/companies'),

    createCompany: (data: any) => api.post<Company>('/api/finance/companies', data),

    updateCompany: (id: string, data: any) => api.put<Company>(`/api/finance/companies/${id}`, data),

    deleteCompany: (id: string) => api.delete(`/api/finance/companies/${id}`),

    // Transactions
    updateTransaction: (id: string, data: any) => api.patch<DirectDebitTransaction>(`/api/finance/direct-debit/transactions/${id}`, data),

    // Attachments
    addAttachment: (data: any) => api.post<DirectDebitAttachment>('/api/finance/direct-debit/attachments', data),
    deleteAttachment: (id: string) => api.delete(`/api/finance/direct-debit/attachments/${id}`),
    getAttachmentDownloadUrl: (id: string, mode: 'view' | 'download' = 'download') => 
        `${API_BASE}/api/finance/direct-debit/attachments/${id}/download?mode=${mode}`,
};
